import React from 'react';

const FacebookIcon = (props) => (
  <svg {...props} viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M8.35004 19.9001C3.60002 19.0501 0 14.9501 0 10C0 4.50002 4.50002 0 10 0C15.5001 0 20.0001 4.50002 20.0001 10C20.0001 14.9501 16.4001 19.0501 11.6501 19.9001L11.1001 19.4501H8.90004L8.35004 19.9001Z'
      fill='url(#paint0_linear_160_170)'
    />
    <path
      d='M13.8999 12.8L14.3499 9.99996H11.6999V8.04995C11.6999 7.24995 11.9999 6.64995 13.1999 6.64995H14.4999V4.09993C13.7999 3.99993 12.9999 3.89993 12.2999 3.89993C9.99992 3.89993 8.39991 5.29994 8.39991 7.79995V9.99996H5.8999V12.8H8.39991V19.85C8.94992 19.95 9.49992 20 10.0499 20C10.5999 20 11.1499 19.95 11.6999 19.85V12.8H13.8999Z'
      fill='white'
    />
    <defs>
      <linearGradient
        id='paint0_linear_160_170'
        x1='10.0005'
        y1='19.3046'
        x2='10.0005'
        y2='-0.00368391'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#0062E0' />
        <stop offset='1' stopColor='#19AFFF' />
      </linearGradient>
    </defs>
  </svg>
);

export default FacebookIcon;
